import * as React from 'react';
import { connect } from 'react-redux';

import AcceptTeamInviteModal from 'components/accept-team-invite-modal/AcceptTeamInviteModal';
import { withModal } from 'components/modal/ModalHOC';

import { getActiveInvitations } from 'modules/organizations/reducers/teamMembers';

type ActiveInvitation = {
  id: number,
  organizationId: number,
  organizationName: string
};

type DispatchProps = {
  dispatchGetActiveInvitation: (userId: number) => Promise<[ActiveInvitation]>
}

type OwnProps = {
  userId?: number,
  isNewAccount: boolean
}

type Props = OwnProps & DispatchProps;

const DivWithModal = withModal(<div />, {
  modalContent: AcceptTeamInviteModal,
  autoOpenModal: true,
  containerClass: 'facebook-button-modal-handler__container',
  showClose: false
});

const AcceptTeamInviteModalManager: React.FC<Props> = ({
  dispatchGetActiveInvitation,
  userId,
  isNewAccount
}) => {
  const [activeInvitation, setActiveInvitation] = React.useState<null | ActiveInvitation>(null);

  React.useEffect(() => {
    (async () => {
      if (userId) {
        const activeInvitations = await dispatchGetActiveInvitation(userId);

        setActiveInvitation(activeInvitations[0] || null);
      }
    })();
  }, [userId]);

  if (!activeInvitation) {
    return null;
  }

  return (
    <div className="facebook-button-manager">
      <DivWithModal
        modalContentProps={{
          profileName: activeInvitation.organizationName,
          orgId: activeInvitation.organizationId,
          isNewAccount,
          userId
        }}
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchGetActiveInvitation: (userId: number) => dispatch(getActiveInvitations(userId))
});

export default connect(null, mapDispatchToProps)(AcceptTeamInviteModalManager);
